'use client'

import { createContext, useContext } from 'react'

/**
 * Height (px) of sticky chrome an ancestor already pins to the top of the
 * page's scrolling <section> -- BaseDashboard's title bar today. Anything
 * below it that also sticks (ResizableTable's toolbar and column headers, a
 * dashboard's own filter bar) stacks under that height instead of sliding
 * behind the bar: a position:sticky header at top:45px with z-10 under a
 * 95px bar with z-20 was simply covered, which is why the column names
 * vanished while scrolling every dashboard built on BaseDashboard
 * (found 2026-09-20). Outside a BaseDashboard the value is 0.
 */
export const StickyStackContext = createContext(0)

export function useStickyStackTop(): number {
  return useContext(StickyStackContext)
}
